import React, { useState, useEffect } from "react";
import { SelectedContainer } from "../../../components/styles";
import { ParagraphStyle } from "./../styles";
import { FormRow, FormGroup } from "../../../styles/forms/main";
import ModalComponent from "./../../../components/modal";
import { setMessage } from "./../../shared/notification/slice";
import CheckBox from "../../../components/checkbox";
import { useDispatch, useSelector } from "react-redux";
import Input from "./../../../components/input";
import { mapDeclineWorkingConditionReasonToData } from "./../mapToData";
import { submitDeclineWorkingCondition } from "./../api";
import trackAnalytics from "../../../trackAnalytics";
import { getUserRoles } from "../../auth/slice";

export default function DeclineModal({
    isShow,
    activeWorkingCondition,
    conditionId,
    onHide,
    conditionStatus,
    projectStatus,
}) {
    const [declineReasons, setDeclineReasons] = useState({
        salesPricing: {},
        supplierPricing: {},
        supplierFulfillment: {},
        clientRequirements: {},
    });
    const [formIsValid, setFormIsValid] = useState(true);
    const dispatch = useDispatch();
    const getCurrentUserRoles = useSelector(getUserRoles());

    useEffect(() => {
        setDeclineReasons({
            salesPricing: {},
            supplierPricing: {},
            supplierFulfillment: {},
            clientRequirements: {},
        });
        setFormIsValid(true);
    }, []);
    const declineModalBody = () => (
        <div>
            <FormRow>
                <ParagraphStyle>Select Decline Reason</ParagraphStyle>
            </FormRow>
            <FormRow>
                <SelectedContainer>
                    <FormRow>
                        <FormGroup>
                            <CheckBox
                                type="checkBox"
                                name="deactivate-reason"
                                inputValue="0"
                                label="Sales Pricing"
                                onChange={(e) => {
                                    setDeclineReasons({
                                        ...declineReasons,
                                        salesPricing: {
                                            ...declineReasons?.salesPricing,
                                            checked: e?.target?.checked,
                                        },
                                    });
                                }}
                            />
                        </FormGroup>
                        {declineReasons?.salesPricing?.checked && (
                            <FormGroup>
                                <Input
                                    type="text"
                                    name="salesPricing"
                                    placeholder="write your comment ....."
                                    disableWithBorder="true"
                                    isEditable="true"
                                    onChange={(e) => {
                                        setDeclineReasons({
                                            ...declineReasons,
                                            salesPricing: {
                                                ...declineReasons?.salesPricing,
                                                comment: e?.target?.value,
                                            },
                                        });
                                    }}
                                    required={declineReasons?.salesPricing?.checked}
                                    error={
                                        !formIsValid &&
                                        (declineReasons?.salesPricing?.comment === "" ||
                                            declineReasons?.salesPricing?.comment === undefined)
                                    }
                                />
                            </FormGroup>
                        )}
                    </FormRow>
                    <FormRow>
                        <FormGroup>
                            <CheckBox
                                type="checkBox"
                                name="deactivate-reason"
                                inputValue="0"
                                label="Supply Pricing"
                                onChange={(e) => {
                                    setDeclineReasons({
                                        ...declineReasons,
                                        supplierPricing: {
                                            ...declineReasons?.supplierPricing,
                                            checked: e?.target?.checked,
                                        },
                                    });
                                }}
                            />
                        </FormGroup>
                        {declineReasons?.supplierPricing?.checked && (
                            <FormGroup>
                                <Input
                                    type="text"
                                    name="supplierPricing"
                                    placeholder="write your comment ....."
                                    disableWithBorder="true"
                                    isEditable="true"
                                    onChange={(e) => {
                                        setDeclineReasons({
                                            ...declineReasons,
                                            supplierPricing: {
                                                ...declineReasons?.supplierPricing,
                                                comment: e?.target?.value,
                                            },
                                        });
                                    }}
                                    required={declineReasons?.supplierPricing?.checked}
                                    error={
                                        !formIsValid &&
                                        (declineReasons?.supplierPricing?.comment === "" ||
                                            declineReasons?.supplierPricing?.comment === undefined)
                                    }
                                />
                            </FormGroup>
                        )}
                    </FormRow>
                    <FormRow>
                        <FormGroup>
                            <CheckBox
                                type="checkBox"
                                name="deactivate-reason"
                                inputValue="0"
                                label="supply Fulfilment"
                                onChange={(e) => {
                                    setDeclineReasons({
                                        ...declineReasons,
                                        supplierFulfillment: {
                                            ...declineReasons?.supplierFulfillment,
                                            checked: e?.target?.checked,
                                        },
                                    });
                                }}
                            />
                        </FormGroup>
                        {declineReasons?.supplierFulfillment?.checked && (
                            <FormGroup>
                                <Input
                                    type="text"
                                    name="supplierFulfillment"
                                    placeholder="write your comment ....."
                                    disableWithBorder="true"
                                    isEditable="true"
                                    onChange={(e) => {
                                        setDeclineReasons({
                                            ...declineReasons,
                                            supplierFulfillment: {
                                                ...declineReasons?.supplierFulfillment,
                                                comment: e?.target?.value,
                                            },
                                        });
                                    }}
                                    required={declineReasons?.supplierFulfillment?.checked}
                                    error={
                                        !formIsValid &&
                                        (declineReasons?.supplierFulfillment?.comment === "" ||
                                            declineReasons?.supplierFulfillment?.comment === undefined)
                                    }
                                />
                            </FormGroup>
                        )}
                    </FormRow>
                    <FormRow>
                        <FormGroup>
                            <CheckBox
                                type="checkBox"
                                name="deactivate-reason"
                                inputValue="0"
                                label="client Requirement"
                                onChange={(e) => {
                                    setDeclineReasons({
                                        ...declineReasons,
                                        clientRequirements: {
                                            ...declineReasons?.clientRequirements,
                                            checked: e?.target?.checked,
                                        },
                                    });
                                }}
                            />
                        </FormGroup>
                        {declineReasons?.clientRequirements?.checked && (
                            <FormGroup>
                                <Input
                                    type="text"
                                    name="client Requirement"
                                    placeholder="write your comment ....."
                                    disableWithBorder="true"
                                    isEditable="true"
                                    onChange={(e) => {
                                        setDeclineReasons({
                                            ...declineReasons,
                                            clientRequirements: {
                                                ...declineReasons?.clientRequirements,
                                                comment: e?.target?.value,
                                            },
                                        });
                                    }}
                                    required={declineReasons?.clientRequirements?.checked}
                                    error={
                                        !formIsValid &&
                                        (declineReasons?.clientRequirements?.comment === "" ||
                                            declineReasons?.clientRequirements?.comment ===
                                                undefined)
                                    }
                                />
                            </FormGroup>
                        )}
                    </FormRow>
                </SelectedContainer>
            </FormRow>
        </div>
    );

    const SubmitDeclineReason = () => {
        const isValid = validateForm();
        if (!isValid) {
            setFormIsValid(false);
        } else {
            setFormIsValid(true);
            submitDecline();
        }
    };
    const submitDecline = () => {
        submitDeclineWorkingCondition(
            mapDeclineWorkingConditionReasonToData(
                mapDeclineReasonData(declineReasons),
                conditionId
            ),
            conditionId
        )
            .then(async (res) => {
                onHide();
                dispatch(
                    setMessage({
                        content: `the project profile condition declined successfully `,
                        isError: false,
                    })
                );
                const extractCheckedReason = () => {
                    const reasons = {};
                    for (let reason in declineReasons) {
                        if (declineReasons[reason]?.checked === true) {
                            reasons[reason] = { declineReason: declineReasons[reason]?.comment };
                        }
                    }
                    return reasons;
                };
                const mixpanelDeclineReasons = extractCheckedReason();
                trackAnalytics("Decline project profile submissions", {
                    "Decline Reasons": mixpanelDeclineReasons,
                    "Working Conditions Status": conditionStatus,
                    "Project Status": projectStatus,
                });
                window.location.reload(true);
            })
            .catch((error) => {
                setMessage({
                    content: error,
                    title: `Couldn't decline the project profile conditions  `,
                    isError: true,
                });
            });
    };
    const validateForm = () => {
        for (const property in declineReasons) {
            if (
                declineReasons[property].checked &&
                (declineReasons[property].comment === undefined ||
                    declineReasons[property].comment === "")
            ) {
                return false;
            }
        }
        return true;
    };

    const mapDeclineReasonData = (data) => {
        const reasons = {};
        for (const property in data) {
            if (data[property].checked) {
                reasons[property] = data[property].comment;
            }
        }
        return reasons;
    };
    return (
        <ModalComponent
            open={isShow}
            grow
            key="addLocation"
            submitBtn
            cancelBtn
            submitBtnText="submit"
            header={` Decline Working Condition #${activeWorkingCondition + 1}`}
            onSubmit={() => {
                SubmitDeclineReason();
            }}
            onClose={(e) => {
                e.preventDefault();
                onHide();
            }}
            closeOnClickOutSide
            isFooter
            size="md"
            disabled={
                !declineReasons?.salesPricing?.checked &&
                !declineReasons?.supplierPricing?.checked &&
                !declineReasons?.supplierFulfillment?.checked &&
                !declineReasons?.clientRequirements?.checked
            }
        >
            <div>{declineModalBody()}</div>
        </ModalComponent>
    );
}
